import React from 'react';
import {useIntl} from 'react-intl';
import {Localise, LocaliseParams} from '@lookiero/promocodes-front';
import {ToastLink} from '../ui/ToastLink';

export type UseFormatMessageResult = {
  formatLocalise: (value: Localise | undefined) => React.ReactNode | string | undefined;
};

const useFormatMessage = (): UseFormatMessageResult => {
  const {formatMessage} = useIntl();

  const parseParams = (params: LocaliseParams = {}): Record<string, string | React.ReactNode> => {
    return Object.entries(params).reduce((previous, current) => {
      const [key, element] = current;

      if (element.link) {
        return {
          ...previous,
          [key]: <ToastLink path={element.link}>{formatMessage({id: element.value})}</ToastLink>,
        };
      }

      return {...previous, [key]: element.value};
    }, {});
  };

  const formatLocalise: UseFormatMessageResult['formatLocalise'] = value => {
    if (!value) return;
    const params = value.params ? parseParams(value.params) : undefined;
    return formatMessage({id: value.id}, params);
  };

  return {formatLocalise};
};

export {useFormatMessage};
